import React, { useEffect, useRef, useState } from "react";
import CSEBTitleImage from "../../images/eBusiness-title.svg";
import CSEBPlatformImage from "../../images/eBusiness-platform.svg";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import LazyLoad from 'react-lazyload';

export default function CsEbusiness(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 100;
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) return;
    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
      setClientHeight(window.innerHeight);
    };
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  //console.log('ce business state: ', elementTop);
  const y = useTransform(scrollY, [elementTop - clientHeight, elementTop - clientHeight + yOffset], [-yOffset, 0], "anticipate");
  return (
    <div className="cs-ebusiness-section section-gap">
      <div className="container">
        <div className="row">
          <div ref={ref} className="col cs-Eb-image">
            <LazyLoad>
              <img src={CSEBTitleImage} className="cb-title-image" alt="eBusiness" title="eBusiness" />
            </LazyLoad>
            <motion.span style={{ y }}>
              <img src={CSEBPlatformImage} className="cb-platform-image" alt="omnichannel retail platform" title="Omnichannel Retail Experience" />
            </motion.span>
          </div>
          <div className="col cs-Eb-content">
            <h2>Omnichannel Experiences Platform</h2>
            <p>Based on customer and market research, we found that customers want a fast, integrated, and intuitive shopping experience across all channels - mobile, web, and stores - that aligns with their grocery shopping habits.  We worked with the HT team to devise an aggressive omnichannel strategy and roadmap to build the eBusiness platform and transform all existing customer-facing channels.</p>
            <h4>The platform integrated 20+ legacy and third-party systems to offer 400+ cross-channel digital and analytics services through APIs to seamlessly power all customer-facing channels - web, mobile, and stores.</h4>
            <p>We orchestrated all dependencies into a reusable Omnichannel API platform to create a consistent and integrated experience across web, mobile, and store. We displaced multiple internal systems and launched new digital products and services with a marginal cost and effort.</p>
          </div>
        </div>
      </div>

    </div>
  );
}